/**
 * home/data/homePipeline.ts — v3.3
 * step3meta: metadatos del archivo fuente para columna izquierda inferior
 */
import type { DocumentExample } from './types';

export const DOCUMENTS: DocumentExample[] = [

  // ── 0 · PRIEGO · ODT · DMS → UTM30 · mojibake clásico ───────────────────
  {
    name: 'PTEL_Priego.odt',
    step1: [
      'Hospital <span class="hl-error">ComarcaÃ±a</span>',
      'Parque Bomberos <span class="hl-error">NÂº</span> 3',
      'Avda. <span class="hl-error">AndalucÃ­a</span>, 12',
      'Ermita <span class="hl-error">NÂª SÂª</span> Fuensanta',
      'C/ <span class="hl-error">JosÃ©</span> Palanca, 5',
      '<span class="hl-error">PolicÃ­a</span> Local',
    ],
    step2: [
      'Hospital <span class="hl-ok" data-dirty="ComarcaÃ±a">Comarcana</span>',
      'Parque Bomberos <span class="hl-ok" data-dirty="NÂº">Nº</span> 3',
      'Avda. <span class="hl-ok" data-dirty="AndalucÃ­a">Andalucía</span>, 12',
      'Ermita <span class="hl-ok" data-dirty="NÂª SÂª">Nª Sª</span> Fuensanta',
      'C/ <span class="hl-ok" data-dirty="JosÃ©">José</span> Palanca, 5',
      '<span class="hl-ok" data-dirty="PolicÃ­a">Policía</span> Local',
    ],
    step3: [
      { from: "37°26'15\"N",   to: 'X: 396284'  },
      { from: "4°11'32\"O",    to: 'Y: 4146823' },
      { from: 'DMS → decimal', to: 'EPSG:25830' },
    ],
    step3meta: [
      { label: 'Formato:',   value: 'ODT (LibreOffice)' },
      { label: 'Encoding:',  value: 'ISO-8859-1' },
      { label: 'CRS orig:',  value: 'EPSG:4326 WGS84' },
      { label: 'Infra.:',    value: '47 elementos' },
    ],
    step4: [
      { label: 'Score:',  value: '94/100 ✓' },
      { label: 'Fuente:', value: 'SICESS (±5m)' },
      { label: 'INE:',    value: '14055 ✓' },
      { label: 'Export:', value: 'GeoJSON' },
    ],
  },

  // ── 1 · GUADIX · XLSX · Y truncada 6→7 dígitos ───────────────────────────
  {
    name: 'PTEL_Guadix.xlsx',
    step1: [
      'IES <span class="hl-error">PeÃ±a</span> Escrita',
      'Avda. <span class="hl-error">MediterrÃ¡neo</span>',
      'C. Salud <span class="hl-error">GuadÃ­x</span> Norte',
      'EDAR <span class="hl-error">AlcantarÃ­lla</span>',
      'Colegio <span class="hl-error">MarÃ­a</span> Aux.',
      'Plaza <span class="hl-error">ConstituciÃ³n</span>',
    ],
    step2: [
      'IES <span class="hl-ok" data-dirty="PeÃ±a">Peña</span> Escrita',
      'Avda. <span class="hl-ok" data-dirty="MediterrÃ¡neo">Mediterráneo</span>',
      'C. Salud <span class="hl-ok" data-dirty="GuadÃ­x">Guadix</span> Norte',
      'EDAR <span class="hl-ok" data-dirty="AlcantarÃ­lla">Alcantarilla</span>',
      'Colegio <span class="hl-ok" data-dirty="MarÃ­a">María</span> Aux.',
      'Plaza <span class="hl-ok" data-dirty="ConstituciÃ³n">Constitución</span>',
    ],
    step3: [
      { from: 'Y: 131456 (6d)', to: 'Y: 4131456' },
      { from: 'Y: 089234 (6d)', to: 'Y: 4089234' },
      { from: 'prefijo «4» ∅',  to: 'auto-fix ✓' },
    ],
    step3meta: [
      { label: 'Formato:',  value: 'XLSX (Excel)' },
      { label: 'Encoding:', value: 'UTF-8 (BOM)' },
      { label: 'CRS orig:', value: 'EPSG:25830' },
      { label: 'Infra.:',   value: '83 elementos' },
    ],
    step4: [
      { label: 'Score:',  value: '91/100 ✓' },
      { label: 'Fuente:', value: 'CartoCiudad (±8m)' },
      { label: 'INE:',    value: '18089 ✓' },
      { label: 'Export:', value: 'GeoJSON' },
    ],
  },

  // ── 2 · COLOMERA · DBF · sep. europeo coma→punto ─────────────────────────
  {
    name: 'PTEL_Colomera.dbf',
    step1: [
      '<span class="hl-error">FARMACIAM.Âª</span> Carmen',
      'C/ <span class="hl-error">EspaÃ±a</span>, 8',
      'Iglesia <span class="hl-error">AsunciÃ³n</span>',
      'Piscina <span class="hl-error">MÃ©nsula</span>',
      'Casa <span class="hl-error">CulturaÃ</span>',
      'CEIP <span class="hl-error">VirgenÂ</span> Cabeza',
    ],
    step2: [
      '<span class="hl-ok" data-dirty="FARMACIAM.Âª">FARMACIA M.ª</span> Carmen',
      'C/ <span class="hl-ok" data-dirty="EspaÃ±a">España</span>, 8',
      'Iglesia <span class="hl-ok" data-dirty="AsunciÃ³n">Asunción</span>',
      'Piscina <span class="hl-ok" data-dirty="MÃ©nsula">Ménsula</span>',
      'Casa <span class="hl-ok" data-dirty="CulturaÃ">Cultura</span>',
      'CEIP <span class="hl-ok" data-dirty="VirgenÂ">Virgen</span> Cabeza',
    ],
    step3: [
      { from: '452.178,34',   to: '452178.34'  },
      { from: '4.139.567,89', to: '4139567.89' },
      { from: 'sep: coma',    to: 'sep: punto'  },
    ],
    step3meta: [
      { label: 'Formato:',  value: 'DBF (dBASE III)' },
      { label: 'Encoding:', value: 'CP850' },
      { label: 'CRS orig:', value: 'EPSG:25830' },
      { label: 'Infra.:',   value: '31 elementos' },
    ],
    step4: [
      { label: 'Score:',  value: '88/100 ✓' },
      { label: 'Fuente:', value: 'CDAU (±10m)' },
      { label: 'INE:',    value: '18051 ✓' },
      { label: 'Export:', value: 'GeoJSON' },
    ],
  },

  // ── 3 · ALFACAR · CSV · WGS84 → UTM30 ───────────────────────────────────
  {
    name: 'PTEL_Alfacar.csv',
    step1: [
      'CEIP <span class="hl-error">GarcÃ­a</span> Lorca',
      'DepÃ³sito <span class="hl-error">MÃ¼nicipal</span>',
      'C/ <span class="hl-error">MÃ¡rtires</span>, 3',
      'Ermita <span class="hl-error">SÃ©rralo</span>',
      'Ayto. <span class="hl-error">AlfÃ¡car</span>',
      'Nave <span class="hl-error">ProtecciÃ³n</span> Civil',
    ],
    step2: [
      'CEIP <span class="hl-ok" data-dirty="GarcÃ­a">García</span> Lorca',
      'Depósito <span class="hl-ok" data-dirty="MÃ¼nicipal">Municipal</span>',
      'C/ <span class="hl-ok" data-dirty="MÃ¡rtires">Mártires</span>, 3',
      'Ermita <span class="hl-ok" data-dirty="SÃ©rralo">Sérralo</span>',
      'Ayto. <span class="hl-ok" data-dirty="AlfÃ¡car">Alfacar</span>',
      'Nave <span class="hl-ok" data-dirty="ProtecciÃ³n">Protección</span> Civil',
    ],
    step3: [
      { from: 'lon: -3.54218', to: 'X: 446823'  },
      { from: 'lat: 37.23451', to: 'Y: 4126547' },
      { from: 'WGS84→ETRS89', to: 'EPSG:25830' },
    ],
    step3meta: [
      { label: 'Formato:',  value: 'CSV (delimitado)' },
      { label: 'Encoding:', value: 'UTF-8' },
      { label: 'CRS orig:', value: 'EPSG:4326 WGS84' },
      { label: 'Infra.:',   value: '28 elementos' },
    ],
    step4: [
      { label: 'Score:',  value: '96/100 ✓' },
      { label: 'Fuente:', value: 'SICESS (±5m)' },
      { label: 'INE:',    value: '18011 ✓' },
      { label: 'Export:', value: 'GeoJSON' },
    ],
  },

  // ── 4 · VÉLEZ-MÁLAGA · ODS · Artículos perdidos/fusionados + mojibake ────
  {
    name: 'PTEL_Velez-Malaga.ods',
    step1: [
      'Hosp. <span class="hl-error">ComarcaÃ‰l</span> Vélez',
      'C/ <span class="hl-error">laÃ©rced</span>, 3',
      'IES <span class="hl-error">Ã‰lPalo</span> Verde',
      'Ermita <span class="hl-error">delasNÂª</span> Remedios',
      'CEIP <span class="hl-error">LosÃ¡lamos</span>',
      'Nave <span class="hl-error">delasIndustrias</span>',
    ],
    step2: [
      'Hosp. <span class="hl-ok" data-dirty="ComarcaÃ‰l">Comarca El</span> Vélez',
      'C/ <span class="hl-ok" data-dirty="laÃ©rced">La Merced</span>, 3',
      'IES <span class="hl-ok" data-dirty="Ã‰lPalo">El Palo</span> Verde',
      'Ermita <span class="hl-ok" data-dirty="delasNÂª">de las Nª</span> Remedios',
      'CEIP <span class="hl-ok" data-dirty="LosÃ¡lamos">Los Álamos</span>',
      'Nave <span class="hl-ok" data-dirty="delasIndustrias">de las Industrias</span>',
    ],
    step3: [
      { from: 'X: 286412 ED50',  to: 'X: 286218' },
      { from: 'Y: 4054891 ED50', to: 'Y: 4054714' },
      { from: 'shift datum',     to: 'Δ ≈ 198 m'  },
    ],
    step3meta: [
      { label: 'Formato:',  value: 'ODS (LibreOffice)' },
      { label: 'Encoding:', value: 'ISO-8859-1' },
      { label: 'CRS orig:', value: 'EPSG:23030 ED50' },
      { label: 'Infra.:',   value: '54 elementos' },
    ],
    step4: [
      { label: 'Score:',  value: '87/100 ✓' },
      { label: 'Fuente:', value: 'CDAU (±12m)' },
      { label: 'INE:',    value: '29901 ✓' },
      { label: 'Export:', value: 'GeoJSON' },
    ],
  },

  // ── 5 · ALMERÍA · GeoJSON · XY concatenados ──────────────────────────────
  {
    name: 'PTEL_Almeria.geojson',
    step1: [
      'Hospital <span class="hl-error">TorrecÃ¡rdenas</span>',
      'EDAR <span class="hl-error">DesaladoÃ±a</span>',
      'IES <span class="hl-error">Al-AndalÃºs</span>',
      'C/ <span class="hl-error">GÃ³ngora</span> nº 12',
      'Pol. <span class="hl-error">LocalAlmerÃ­a</span>',
      'Centro <span class="hl-error">SaludÃ‡urchill</span>',
    ],
    step2: [
      'Hospital <span class="hl-ok" data-dirty="TorrecÃ¡rdenas">Torrecárdenas</span>',
      'EDAR <span class="hl-ok" data-dirty="DesaladoÃ±a">Desaladora</span>',
      'IES <span class="hl-ok" data-dirty="Al-AndalÃºs">Al-Andalús</span>',
      'C/ <span class="hl-ok" data-dirty="GÃ³ngora">Góngora</span> nº 12',
      'Pol. <span class="hl-ok" data-dirty="LocalAlmerÃ­a">Local Almería</span>',
      'Centro <span class="hl-ok" data-dirty="SaludÃ‡urchill">Salud Churchill</span>',
    ],
    step3: [
      { from: '562134409123',  to: 'X: 562134'  },
      { from: '(XY fundidos)', to: 'Y: 4091234' },
      { from: 'auto-split ✓', to: 'EPSG:25830' },
    ],
    step3meta: [
      { label: 'Formato:',  value: 'GeoJSON' },
      { label: 'Encoding:', value: 'UTF-8' },
      { label: 'CRS orig:', value: 'EPSG:25830' },
      { label: 'Infra.:',   value: '119 elementos' },
    ],
    step4: [
      { label: 'Score:',  value: '92/100 ✓' },
      { label: 'Fuente:', value: 'DERA (±8m)' },
      { label: 'INE:',    value: '04013 ✓' },
      { label: 'Export:', value: 'GeoJSON' },
    ],
  },
];
